export function chunkArray<T>(arr: T[] = [], chunkSize: number): T[][] {
  if (chunkSize <= 0) {
    return [arr];
  }

  return Array.from({ length: Math.ceil(arr.length / chunkSize) }, (_, i) =>
    arr.slice(i * chunkSize, i * chunkSize + chunkSize)
  );
}
